import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Loading } from '../components/loading/Loading';
import { ProtectedRoute } from './ProtectedRoute';

const AdminProfile = lazy(() => import('../pages/admin-profile/AdminProfile'));
const AdminDashboard = lazy(() => import('../pages/admin-profile/dashboard/AdminDashboard'));
const Properties = lazy(() => import('../pages/admin-profile/properties/Properties'));
const AdminReservations = lazy(() => import('../pages/admin-profile/reservations/AdminReservations'));
const AdminReservationsDetail = lazy(
  () => import('../pages/admin-profile/reservations/details/AdminReservationDetails'),
);
const Contact = lazy(() => import('../pages/contact/Contact'));
const ForgotPassword = lazy(() => import('../pages/forgot-password/ForgotPassword'));
const Home = lazy(() => import('../pages/home/Home'));
const EditListingForm = lazy(() => import('../pages/listing-form/EditListingForm'));
const ListingForm = lazy(() => import('../pages/listing-form/ListingForm'));
const Listing = lazy(() => import('../pages/listing/Listing'));
const Listings = lazy(() => import('../pages/listings/Listings'));
const Login = lazy(() => import('../pages/login/Login'));
const OwnerProfile = lazy(() => import('../pages/owner-profile/OwnerProfile'));
const MyProperties = lazy(() => import('../pages/owner-profile/my-properties/MyProperties'));
const OwnerReservations = lazy(() => import('../pages/owner-profile/owner-reservations/OwnerReservations'));
const OwnerReservationDetail = lazy(
  () => import('../pages/owner-profile/owner-reservations/details/OwnerReservationDetails'),
);
const PersonalData = lazy(() => import('../pages/owner-profile/peronal-data/PeronalData'));
const Partners = lazy(() => import('../pages/partners/Partners'));
const PartnerBusinessTerms = lazy(() => import('../pages/partner-business-terms/PartnerBusinessTerms'));
const PrivacyStatement = lazy(() => import('../pages/privacy-statement/PrivacyStatement'));
const Register = lazy(() => import('../pages/register/Register'));
const TermsAndConditions = lazy(() => import('../pages/terms-and-conditions/TermsAndConditions'));
const UserProfile = lazy(() => import('../pages/user-profile/UserProfile'));
const UserPersonalData = lazy(() => import('../pages/user-profile/peronal-data/UserPeronalData'));
const UserReservations = lazy(() => import('../pages/user-profile/user-reservations/UserReservations'));
const UserReservationDetail = lazy(
  () => import('../pages/user-profile/user-reservations/details/UserReservationDetails'),
);

export const Routing = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path='/' element={<Navigate to='/home' />} />
        <Route path='/home' element={<Home />} />
        <Route path='/login' element={<Login />} />
        <Route path='/partner-profile' element={<OwnerProfile />}>
          <Route
            index
            element={
              <Suspense fallback={<Loading />}>
                <PersonalData />
              </Suspense>
            }
          />
          <Route
            path='personal-data'
            element={
              <Suspense fallback={<Loading />}>
                <PersonalData />
              </Suspense>
            }
          />
          <Route
            path='my-properties'
            element={
              <Suspense fallback={<Loading />}>
                <MyProperties />
              </Suspense>
            }
          />
          <Route
            path='reservations'
            element={
              <Suspense fallback={<Loading />}>
                <OwnerReservations />
              </Suspense>
            }
          />
        </Route>
        <Route path='/user-profile' element={<UserProfile />}>
          <Route
            index
            element={
              <Suspense fallback={<Loading />}>
                <UserPersonalData />
              </Suspense>
            }
          />
          <Route
            path='personal-data'
            element={
              <Suspense fallback={<Loading />}>
                <UserPersonalData />
              </Suspense>
            }
          />
          <Route
            path='reservations'
            element={
              <Suspense fallback={<Loading />}>
                <UserReservations />
              </Suspense>
            }
          />
        </Route>
        <Route
          path='reservations/:reservationId'
          element={
            <ProtectedRoute>
              <OwnerReservationDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path='admin-reservations/:reservationId'
          element={
            <ProtectedRoute>
              <AdminReservationsDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path='user-reservations/:reservationId'
          element={
            <ProtectedRoute>
              <UserReservationDetail />
            </ProtectedRoute>
          }
        />
        <Route path='/admin-profile' element={<AdminProfile />}>
          <Route
            index
            element={
              <Suspense fallback={<Loading />}>
                <AdminDashboard />
              </Suspense>
            }
          />
          <Route
            path='dashboard'
            element={
              <Suspense fallback={<Loading />}>
                <AdminDashboard />
              </Suspense>
            }
          />
          <Route
            path='properties'
            element={
              <Suspense fallback={<Loading />}>
                <Properties />
              </Suspense>
            }
          />
          <Route
            path='reservations'
            element={
              <Suspense fallback={<Loading />}>
                <AdminReservations />
              </Suspense>
            }
          />
        </Route>
        <Route path='/register' element={<Register />} />
        <Route path='/listings' element={<Listings />} />
        <Route path='/listings/:listingId' element={<Listing />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/listing-form' element={<ListingForm />} />
        <Route path='/edit-listing-form/:listingId' element={<EditListingForm />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
        <Route path='/uvjeti-poslovanja-za-partnere' element={<PartnerBusinessTerms />} />
        <Route path='/privacy-statement' element={<PrivacyStatement />} />
        <Route path='/partners' element={<Partners />} />
      </Routes>
    </Suspense>
  );
};
